import { bindActionCreators, compose } from 'redux';
import { getOpenModal, openAbsenteeBidModal } from '@/redux/modules/modal';
import { parseQueryParams, removeQueryParams, stringifyQuery } from '@/utils/queryParams';
import React, { Component } from 'react';
import { BiddingInfo } from '@/types/BiddingInfo';
import { connect } from 'react-redux';
import { fetchLiveCatalogRegistrationIfNeeded } from '@/redux/modules/catalogRegistration';
import { fetchLiveCatalogStatusIfNeeded } from '@/redux/modules/liveCatalogStatus';
import { getBiddingInfo } from '@/redux/modules/biddingInfo';
import { getCatalog } from '@/redux/modules/catalog';
import { getItem } from '@/redux/modules/item';
import { getLiveCatalogData } from '@/redux/modules/console';
import { getLiveItemStatus } from '@/redux/modules/liveItemStatus';
import isEqual from 'react-fast-compare';
import { isUserLoggedIn } from '@/redux/modules/user';
import ItemBidding from './ItemBidding';
import { modalTypes } from '@/enums';
import { push as navigate } from 'connected-react-router';
import { withRouter } from 'react-router-dom';

type OwnProps = {
    itemId: number;
};

const mapStateToProps = (state, { itemId, location }) => {
    const biddingInfo = getBiddingInfo(state, itemId);
    const { catalogId } = getItem(state, itemId);
    const userLoggedIn = isUserLoggedIn(state);
    const { open: isLotOpen } = getLiveItemStatus(state, itemId);
    const { catalogStatus, isCatalogOnly } = getCatalog(state, catalogId);
    const { status: liveCatalogStatus } = getLiveCatalogData(state, catalogId);
    const queryParams: any = parseQueryParams(location.search);
    const isFromEmail = queryParams.action === 'bidnow';
    const bidModalOpen = getOpenModal(state) === modalTypes.ABSENTEE_BID;

    return {
        biddingInfo,
        bidModalOpen,
        catalogId,
        catalogStatus,
        isCatalogOnly,
        isFromEmail,
        isLotOpen,
        liveCatalogStatus,
        queryParams,
        userLoggedIn,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchLiveCatalogRegistrationIfNeeded,
            fetchLiveCatalogStatusIfNeeded,
            navigate,
            openAbsenteeBidModal,
        },
        dispatch
    );

type ReduxProps = {
    bidModalOpen: boolean;
    biddingInfo: BiddingInfo;
    catalogId: number;
    catalogStatus: string;
    isCatalogOnly: boolean;
    isFromEmail: boolean;
    isLotOpen: boolean;
    liveCatalogStatus: string;
    onCountdownEnd: Function;
    queryParams: any;
    userLoggedIn: boolean;
};

type ReduxActions = {
    fetchLiveCatalogRegistrationIfNeeded: Function;
    fetchLiveCatalogStatusIfNeeded: Function;
    navigate: Function;
    openAbsenteeBidModal: Function;
};

type Props = OwnProps & ReduxProps & ReduxActions;

class ItemBiddingContainer extends Component<Props> {
    static defaultProps = {
        biddingInfo: {},
        userLoggedIn: false,
    };

    componentDidMount() {
        const { catalogId, catalogStatus, liveCatalogStatus, userLoggedIn } = this.props;

        if (userLoggedIn && (catalogStatus === 'live' || liveCatalogStatus === 'live')) {
            this.props.fetchLiveCatalogRegistrationIfNeeded(catalogId);
        }
        if (catalogStatus === 'live' || liveCatalogStatus === 'live') {
            this.props.fetchLiveCatalogStatusIfNeeded(catalogId);
        }
    }

    shouldComponentUpdate = (nextProps) => !isEqual(this.props, nextProps);

    componentDidUpdate(prevProps) {
        const {
            biddingInfo,
            catalogId,
            catalogStatus,
            isCatalogOnly,
            isLotOpen,
            liveCatalogStatus,
            userLoggedIn,
        } = this.props;
        if (userLoggedIn && !prevProps.userLoggedIn && (catalogStatus === 'live' || liveCatalogStatus === 'live')) {
            this.props.fetchLiveCatalogRegistrationIfNeeded(catalogId);
        }
        if (catalogStatus === 'live' || liveCatalogStatus === 'live') {
            this.props.fetchLiveCatalogStatusIfNeeded(catalogId);
        }

        if (!this.props.bidModalOpen && this.props.isFromEmail) {
            this.removeQueryParams(['action']);

            const { isLocked, isPassed, isSold } = biddingInfo;

            const isUnsold = isLocked && !isPassed && !isSold && !isLotOpen;

            // Don't open model from email link if item isn't upcoming
            if (isPassed || isSold || isUnsold || isCatalogOnly) {
                return;
            }

            this.props.openAbsenteeBidModal(this.props.itemId, 0);
        }
    }

    removeQueryParams = (keys) => {
        const query = removeQueryParams(this.props.queryParams, keys);
        this.props.navigate({
            search: stringifyQuery(query),
        });
    };

    render() {
        const { itemId, onCountdownEnd } = this.props;

        return <ItemBidding itemId={itemId} onCountdownEnd={onCountdownEnd} />;
    }
}

// @ts-ignore
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ItemBiddingContainer);
